import { ActionBase } from '../../../core/store/action/ActionBase';
import { ModuleConfiguration } from '../../datawarehouse.module.config';
import { NextgateSyncModel } from '../../models/NextgateSyncModel';

export const SYNC_WITH_NEXTGATE_RESPONSE = `[${ModuleConfiguration.moduleName}] Sync With Nextgate Response`;

export class SyncWithNextgateResponseAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = SYNC_WITH_NEXTGATE_RESPONSE;

  constructor(public payload: { key: string, result: NextgateSyncModel }) {}
}


// WEBPACK FOOTER //
// ./src/app/datawarehouse/store/actions/SyncWithNextgateResponseAction.ts